export default {
  title: {
    text: "正极材料种类占比",
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: ({d}%)",
  },
  // legend: {
  //   top: 50,
  //   data: ["三元材料NMC", "磷酸铁锂", "锰酸锂", "钴酸锂"],
  // },
  series: [
    {
      name: "新能源电池正极材料",
      type: "pie",
      radius: ["50%", "60%"],
      center: ["50%", "60%"],

      data: [
        { value: 0.4858, name: "三元材料" },
        { value: 0.23, name: "磷酸铁锂" },
        { value: 0.1292, name: "锰酸锂" },
        { value: 0.155, name: "钴酸锂" },
      ],
    },
  ],
};
